import React from 'react';
import { Link } from 'react-router-dom';

const LPFooter = () => {
  return (
    <footer className="bg-lp-charcoal text-white/70 py-10 px-5">
      <div className="max-w-[960px] mx-auto text-center space-y-4">
        <img
          src={`${process.env.PUBLIC_URL}/images/logo.svg`}
          alt="SrWith"
          className="h-10 w-auto mx-auto filter brightness-0 invert"
        />
        <div className="flex justify-center gap-6 text-xs">
          <Link to="/" className="hover:text-white transition-colors">SrWith トップ</Link>
          <Link to="/service" className="hover:text-white transition-colors">サービス紹介</Link>
          <Link to="/download" className="hover:text-white transition-colors">資料ダウンロード</Link>
          <Link to="/partner" className="hover:text-white transition-colors">パートナー事務所</Link>
          <Link to="/contact" className="hover:text-white transition-colors">お問い合わせ</Link>
          <Link to="/lp/academy/cancellation-policy" className="hover:text-white transition-colors">キャンセルポリシー</Link>
        </div>
        <p className="text-xs">
          SrWith株式会社　|　佐賀県唐津市和多田海士町5-14
        </p>
        <p className="text-xs text-white/40">
          &copy; 2026 SrWith株式会社
        </p>
      </div>
    </footer>
  );
};

export default LPFooter;
